export interface ILocale {
  countryCode: string;
  language?: string;
  timezoneId?: string;
  timezone?: string;
}
